/* eslint-disable no-unused-vars */
/* eslint-disable require-jsdoc */
import { Brief } from "./Brief";
import { Letter } from "./Letter";
import { Mechanism } from "./Mechanism";
import { Research } from "./Research";
import "firebase/firestore";
import { EditorSettings } from "./EditorSettings";
/**
 * Offer class.
 */
export class Offer {
    constructor() {
        this.name = "";
        this.research = new Research();
        this.mechanism = new Mechanism();
        this.brief = new Brief();
        this.letters = [new Letter()];
        this.editorSettings = new EditorSettings();
    }
}
